import UnaCourse from "../../assets/una-course-2x.png";

const CourseBanner = ({ url }) => {
  return (
    <div
      className="min-[725px]:h-[350px] h-36 bg-[#ccc] bg-no-repeat bg-cover bg-center border-b-[#ccc] border-t-0 border-x-0 border-b border-solid w-full 2xl:max-w-[1536px] 2xl:m-auto"
      style={{
        backgroundImage: `${url ? `url(${url})` : `url(${UnaCourse})`}`,
      }}
    >
      <div className="overflow-hidden flex h-full justify-center m-auto"></div>
    </div>
  );
};

export default CourseBanner;
